import { render, staticRenderFns } from "./detailsList.vue?vue&type=template&id=cc0e1f26&scoped=true"
import script from "./detailsList.vue?vue&type=script&lang=js"
export * from "./detailsList.vue?vue&type=script&lang=js"
import style0 from "./detailsList.vue?vue&type=style&index=0&id=cc0e1f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0e1f26",
  null
  
)

export default component.exports